import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Login component that handles authentication through Auth0
 * @returns {JSX.Element} The login component
 */
const Login: React.FC = () => {
  const { loginWithRedirect } = useAuth0()
  const location = useLocation()
  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/form'

  const handleLogin = async () => {
    try {
      await loginWithRedirect({
        appState: { returnTo: from },
      })
    } catch (error) {
      console.error('Login error:', error)
    }
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden">
      <div className="relative z-10 w-full max-w-md p-8">
        <div className="rounded-lg bg-black p-8 shadow-xl">
          <div className="text-center">
            <div className="mb-6 flex justify-center">
              <img src="/icons/Inflection_Icon_Light 1.svg" alt="Inflection Logo" className="h-16 w-auto" />
            </div>
          </div>
          <div className="mt-8">
            <button
              onClick={handleLogin}
              className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-3 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Sign in with Auth0
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
